import { createApp } from 'vue';

import App from './App.vue';
import { createAppRouter } from './router/index.js';

createApp(App).use(createAppRouter()).mount('#app');
